import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { useCookieConsent } from '@context/CookieConsentContext';

/**
 * Cookie consent banner. Optional (analytics) technologies are only enabled
 * after the user accepts here — see CookieConsentProvider + firebase.ts.
 */
const CookieBanner: React.FC = () => {
  const { bannerOpen, acceptOptional, rejectOptional } = useCookieConsent();

  if (!bannerOpen) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie choices"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4"
    >
      <div className="max-w-3xl mx-auto bg-white rounded-2xl border-2 border-gray-100 shadow-2xl p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-primary-50 text-primary-300 flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-text-secondary">
              We use essential cookies to keep RoomZa secure and working. With your permission we
              also use optional analytics to understand and improve RoomZa. See our{' '}
              <Link to="/legal/cookies" className="text-primary-300 font-semibold underline underline-offset-2">
                Cookie Notice
              </Link>
              .
            </p>
            <div className="flex flex-col sm:flex-row gap-2 mt-3">
              <button
                type="button"
                onClick={acceptOptional}
                className="btn-primary text-sm py-2 px-4"
              >
                Accept optional cookies
              </button>
              <button
                type="button"
                onClick={rejectOptional}
                className="btn-secondary text-sm py-2 px-4"
              >
                Reject optional cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
